import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {
	
	constructor(
		private router: Router, 
		private authService: AuthenticationService,
		private snackbar: MatSnackBar
	) {}
	
	canActivate() {
		var role = this.authService.getRole();
		
		if (role == "super_admin") {
			return true;
		} else {
			this.snackbar.open("Je hebt niet voldoende rechten", 'Sluiten', {duration: 3000});
			this.router.navigate(['/admin']);	
			return false;
		}
	}
}
	